module.exports = __webpack_public_path__ + "static/media/bankIcon (1).6e779064.svg";